<template>
  <v-form v-async-form v-model="valid" ref="audienceNameForm">
    <v-text-field
      ref="audienceName"
      :dark="attributePanel"
      :outlined="attributePanel"
      :dense="attributePanel"
      v-async-validate
      name="audienceName"
      :label="attributePanel ? '' : 'Audience Name'"
      id="audienceName"
      :class="attributePanel ? 'left-text' : 'centered-text'"
      autocomplete="off"
      v-focus.lazy="true"
      @focus="targetNameFocusHandler"
      :disabled="disabled"
      v-model.trim="display_name"
      v-on:blur="targetNameOutOfFocusHandler"
      :async-rules="$_rules.audienceName"
    ></v-text-field>
  </v-form>
</template>

<script>
  import { focus } from 'vue-focus'
  import { validateTargetName } from '@/api'
  import OneToast from '@/components/common/toasts/OneToast'
  import {TARGET_TYPE, TARGET_ACTIONS} from '@/appLogic/targets/Constants'

  const MAX_NAME_LENGTH = 100
  const MIN_NAME_LENGTH = 5
  const Toast = new OneToast()
  export default {
    props: {
      classOverride: {
        type: String,
        default: ''
      },
      isNewTarget: {
        type: Boolean,
        default: false
      },
      attributePanel: {
        type: Boolean,
        default: false
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      initialValue: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      isValid: {
        type: Boolean,
        default: false
      },
      validRegex: {
        default: () => /^[A-Za-z0-9_]*$/
      },
      validFirstCharRegex: {
        default: () => /^[A-Za-z][A-Za-z0-9_]*$/
      },
      initialTargetAction: {
        type: String,
        default: ''
      },
      displayOverride: {
        type: String,
        default: null
      },
      // use to valid all the changes of the name, when valid or invalid.
      // this will also validate the name when the component is mounted with an initial name value
      validateAllNames: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        duplicateToast: null,
        display_name: this.displayOverride !== null ? this.displayOverride || '' : this.initialValue,
        nameIsValid: null,
        nameClass: null,
        isDigitalSocialDestination: false,
        currentValueFromResp: '',
        valid: false,
        outOfFocus: false,
      }
    },
    mounted () {
      this.isDigitalSocialDestination = this.$parent.isDigitalSocialDestination
      if (this.display_name) {
        this.$refs.audienceNameForm.validateAsync()
        setTimeout(() => {
          this.$emit('updateNameIsValid', this.valid)
        }, 1000)
      }
    },
    computed: {
      originalTargetName () {
        return this.$store.state.currentTarget.currentTarget.display_name
      },
    },
    directives: {
      focus
    },
    watch: {
      initialValue: {
        immediate: true,
        handler (value) {
          if (this.initialTargetAction === TARGET_ACTIONS.DUPLICATE) {
            this.display_name = `${this.initialValue}_COPY`
            this.$emit('updateName', this.display_name)
          } else {
            this.display_name = this.initialValue
          }
        }
      },
      display_name () {
        this.$emit('updateNameIsValid', false)
        if (this.display_name.length >= MIN_NAME_LENGTH) {
          this.$emit('updateName', this.display_name)
          setTimeout(() => {
            this.$emit('updateNameIsValid', this.valid && this.display_name)
          }, 1000)
        }
      },
      '$parent.value.destinations': function () {
        this.isDigitalSocialDestination = this.$parent.isDigitalSocialDestination
      },
    },
    created: function () {
      this.$_rules = {
        audienceName: [this.audienceNameRules()],
      }
    },
    methods: {
      targetNameFocusHandler (e) {
        this.outOfFocus = false
        // select the target name input text if its a new target that is being duplicated and the name hasn't changed
        if (this.isNewTarget && this.display_name === this.initialValue) {
          if (this.initialTargetAction === TARGET_ACTIONS.DUPLICATE) {
            e.target.select()
          } else {
            this.$emit('updateName', this.display_name)
          }
        }
      },
      targetNameOutOfFocusHandler (e) {
        this.outOfFocus = true
        this.$refs.audienceName.validateAsync()
      },
      audienceNameRules () {
        return (value) => {
          if (this.disabled) {
            return true
          }

          if (!value && this.outOfFocus) {
            return "Required"
          } else if (value.length > MAX_NAME_LENGTH) {
            return `Max ${MAX_NAME_LENGTH} character`
          } else if (value.length < MIN_NAME_LENGTH && this.outOfFocus) {
            return `Must be ${MIN_NAME_LENGTH} characters or more`
          } else if (value.length > 0 && !this.validRegex.test(value)) {
            return 'Allowed characters are A-Z, a-z, 0-9, _'
          } else if (value.length > 0 && !this.validFirstCharRegex.test(value)) {
            return 'Must start with an alphabet'
          } else if (value === this.originalTargetName && this.isNewTarget) {
            return false
          } else if (value === this.initialValue && !this.isNewTarget && this.initialTargetAction !== TARGET_ACTIONS.DUPLICATE) {
            return true
          } else if (value.length >= MIN_NAME_LENGTH) {
            return new Promise(resolve => {
              validateTargetName({display_name: value}).then(({data}) => {
                if (!this.isUpdating) {
                  this.currentValueFromResp = value
                  if (data.passNameLookup === false) {
                    return resolve('Duplicate Audience Name')
                  } else if (data.passedPruning === false) {
                    return resolve('Invalid Characters in Audience Name')
                  }
                }
              })
            })
          } else {
            return true
          }
        }
      },
    }
  }

</script>

<style lang="scss">
    /* Please refer to TargetFormStyles to add styles to this form */
  .centered-text input {
    text-align: center
  }
</style>



// WEBPACK FOOTER //
// TargetName.vue?cc97b3fe